import PTag from './src/tag';

/* istanbul ignore next */
PTag.install = function (Vue) {
  Vue.component(PTag.name, PTag);
};

export default PTag;
